import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isNaturalLanguageGhostTextEnabled(): boolean {
    return (
        isFeatureEnabled('sea-teachNL-ghostText') &&
        getUserConfiguration().SessionSettings.UserLanguage === 'en'
    );
}
